import React from 'react';
export function Logo({
  className = 'w-8 h-8',
  color = 'currentColor'
}: {
  className?: string;
  color?: string;
}) {
  return <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-81">
      <path d="M50 95V60" stroke={color} strokeWidth="6" strokeLinecap="round" data-id="element-82" />
      <path d="M50 60C50 60 25 70 25 40C25 20 50 15 50 15C50 15 75 20 75 40C75 70 50 60 50 60Z" fill={color} data-id="element-83" />
      <path d="M45 65C45 65 20 80 10 55C0 30 35 35 35 35C35 35 45 50 45 65Z" fill={color} data-id="element-84" />
      <path d="M55 65C55 65 80 80 90 55C100 30 65 35 65 35C65 35 55 50 55 65Z" fill={color} data-id="element-85" />
    </svg>;
}